<template>
    <div
        :style="'transform: scale(' + size + ');'"
        class="uik-loader">
        <div v-if="type == 'spinner'" class="uik-loader__spinner">
            <div v-for="i in 12" :key="i"><div :style="customColor" :class="variableColor"/></div>
        </div>
        <div v-if="type == 'spinner-fade'" class="uik-loader__spinner-fade">
            <div v-for="i in 12" :key="i"><div :style="customColor" :class="variableColor"/></div>
        </div>
        <div v-if="type == 'bounce'" class="uik-loader__bounce">
            <div v-for="i in 2" :key="i" :style="customColor" :class="variableColor"/>
        </div>
        <div v-if="type == 'ripple'" class="uik-loader__ripple" :style="customColor" :class="variableColor"/>
        <div v-if="type == 'dots'" class="uik-loader__dots">
            <div v-for="i in 3" :key="i" :style="customColor" :class="variableColor"/>
        </div>
        <div v-if="type == 'bars'" class="uik-loader__bars">
            <div v-for="i in 5" :key="i" :style="customColor" :class="variableColor"/>
        </div>
        <div v-if="type == 'blocks'" class="uik-loader__blocks">
            <div v-for="i in 9" :key="i" :style="customColor" :class="variableColor"/>
        </div>
        <div v-if="type == 'rotate'" class="uik-loader__rotate" :style="customColor" :class="variableColor"/>
        <div v-if="type == 'fold'" class="uik-loader__fold">
            <div v-for="i in 4" :key="i"><div :style="customColor" :class="variableColor"/></div>
        </div>
        <div v-if="type == 'cubes'" class="uik-loader__cubes">
            <div v-for="i in 2" :key="i" :style="customColor" :class="variableColor"/>
        </div>
    </div>
</template>

<script>
// Loader types: "spinner", "spinner-fade", "bounce", "ripple", "dots", "bars", "blocks", "rotate", "fold", "cubes"
export default {
    name: "UikLoader",
    props: {
        color: { type: String, default: "white" },
        type: { type: String, default: "spinner" },
        size: { type: Number, default: 1 }
    },
    computed: {
        customColor () {
            if (
                this.color !== "primary" &&
                this.color !== "secondary" &&
                this.color !== "success" &&
                this.color !== "error" &&
                this.color !== "warning" &&
                this.color !== "textMain" &&
                this.color !== "textSecondary"
            ) {
                return "background-color: " + this.color + ";"
            } else {
                return ""
            }
        },
        variableColor () {
            if (this.color === "primary") return "primary"
            if (this.color === "secondary") return "secondary"
            if (this.color === "success") return "success"
            if (this.color === "error") return "error"
            if (this.color === "warning") return "warning"
            if (this.color === "textMain") return "textMain"
            if (this.color === "textSecondary") return "textSecondary"
            return ""
        }
    }
}
</script>

<style lang="scss">
.uik-loader {
    display: inline-block;
    .uik-loader__spinner {
        margin: 0 auto;
        width: 40px;
        height: 40px;
        position: relative;
        > div {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            div {
                display: block;
                margin: 0 auto;
                width: 15%;
                height: 15%;
                border-radius: 50%;
                animation: uik-loader-spinner 1.2s infinite ease-in-out both;
            }
        }
        > div:nth-child(2) {
            transform: rotate(30deg);
            div {
                animation-delay: -1.1s;
            }
        }
        > div:nth-child(3) {
            transform: rotate(60deg);
            div {
                animation-delay: -1s;
            }
        }
        > div:nth-child(4) {
            transform: rotate(90deg);
            div {
                animation-delay: -0.9s;
            }
        }
        > div:nth-child(5) {
            transform: rotate(120deg);
            div {
                animation-delay: -0.8s;
            }
        }
        > div:nth-child(6) {
            transform: rotate(150deg);
            div {
                animation-delay: -0.7s;
            }
        }
        > div:nth-child(7) {
            transform: rotate(180deg);
            div {
                animation-delay: -0.6s;
            }
        }
        > div:nth-child(8) {
            transform: rotate(210deg);
            div {
                animation-delay: -0.5s;
            }
        }
        > div:nth-child(9) {
            transform: rotate(240deg);
            div {
                animation-delay: -0.4s;
            }
        }
        > div:nth-child(10) {
            transform: rotate(270deg);
            div {
                animation-delay: -0.3s;
            }
        }
        > div:nth-child(11) {
            transform: rotate(300deg);
            div {
                animation-delay: -0.2s;
            }
        }
        > div:nth-child(12) {
            transform: rotate(330deg);
            div {
                animation-delay: -0.1s;
            }
        }
    }
    .uik-loader__spinner-fade {
        margin: 0 auto;
        width: 40px;
        height: 40px;
        position: relative;
        > div {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            div {
                display: block;
                margin: 0 auto;
                width: 15%;
                height: 15%;
                border-radius: 100%;
                animation: uik-loader-spinner-fade 1.2s infinite ease-in-out both;
            }
        }
        > div:nth-child(2) {
            transform: rotate(30deg);
            div {
                animation-delay: -1.1s;
            }
        }
        > div:nth-child(3) {
            transform: rotate(60deg);
            div {
                animation-delay: -1s;
            }
        }
        > div:nth-child(4) {
            transform: rotate(90deg);
            div {
                animation-delay: -0.9s;
            }
        }
        > div:nth-child(5) {
            transform: rotate(120deg);
            div {
                animation-delay: -0.8s;
            }
        }
        > div:nth-child(6) {
            transform: rotate(150deg);
            div {
                animation-delay: -0.7s;
            }
        }
        > div:nth-child(7) {
            transform: rotate(180deg);
            div {
                animation-delay: -0.6s;
            }
        }
        > div:nth-child(8) {
            transform: rotate(210deg);
            div {
                animation-delay: -0.5s;
            }
        }
        > div:nth-child(9) {
            transform: rotate(240deg);
            div {
                animation-delay: -0.4s;
            }
        }
        > div:nth-child(10) {
            transform: rotate(270deg);
            div {
                animation-delay: -0.3s;
            }
        }
        > div:nth-child(11) {
            transform: rotate(300deg);
            div {
                animation-delay: -0.2s;
            }
        }
        > div:nth-child(12) {
            transform: rotate(330deg);
            div {
                animation-delay: -0.1s;
            }
        }
    }
    .uik-loader__bounce {
        width: 40px;
        height: 40px;
        position: relative;
        margin: 0 auto;
        div {
            width: 100%;
            height: 100%;
            border-radius: 50%;
            opacity: 0.6;
            position: absolute;
            top: 0;
            left: 0;
            animation: uik-loader-bounce 2.0s infinite ease-in-out;
        }
        div:nth-child(2) {
            animation-delay: -1.0s;
        }
    }
    .uik-loader__ripple {
        width: 40px;
        height: 40px;
        margin: 0 auto;
        border-radius: 100%;
        animation: uik-loader-ripple 1.0s infinite ease-in-out;
    }
    .uik-loader__dots {
        width: 70px;
        margin: 0 auto;
        text-align: center;
        div {
            width: 18px;
            height: 18px;
            border-radius: 100%;
            display: inline-block;
            margin: 0 3px;
            animation: uik-loader-dots 1.4s infinite ease-in-out both;
        }
        div:nth-child(1) {
            animation-delay: -0.32s;
            margin-left: 0;
        }
        div:nth-child(2) {
            animation-delay: -0.16s;
        }
        div:nth-child(3) {
            margin-right: 0;
        }
    }
    .uik-loader__bars {
        width: 40px;
        height: 40px;
        margin: 0 auto;
        text-align: center;
        font-size: 10px;
        div {
            margin: 0 1px;
            height: 100%;
            width: 6px;
            display: inline-block;
            animation: uik-loader-bars 1.2s infinite ease-in-out;
        }
        div:nth-child(1) {
            margin-left: 0;
        }
        div:nth-child(2) {
            animation-delay: -1.1s;
        }
        div:nth-child(3) {
            animation-delay: -1.0s;
        }
        div:nth-child(4) {
            animation-delay: -0.9s;
        }
        div:nth-child(5) {
            animation-delay: -0.8s;
            margin-right: 0;
        }
    }
    .uik-loader__blocks {
        width: 40px;
        height: 40px;
        margin: 0 auto;
        div {
            width: 33%;
            height: 33%;
            float: left;
            animation: uik-loader-blocks 1.3s infinite ease-in-out;
        }
        div:nth-child(1) {
            animation-delay: 0.2s;
        }
        div:nth-child(2) {
            animation-delay: 0.3s;
        }
        div:nth-child(3) {
            animation-delay: 0.4s;
        }
        div:nth-child(4) {
            animation-delay: 0.1s;
        }
        div:nth-child(5) {
            animation-delay: 0.2s;
        }
        div:nth-child(6) {
            animation-delay: 0.3s;
        }
        div:nth-child(8) {
            animation-delay: 0.1s;
        }
        div:nth-child(9) {
            animation-delay: 0.2s;
        }
    }
    .uik-loader__rotate {
        width: 40px;
        height: 40px;
        margin: 0 auto;
        animation: uik-loader-rotate 1.2s infinite ease-in-out;
    }
    .uik-loader__fold {
        width: 40px;
        height: 40px;
        margin: 0 auto;
        transform: rotateZ(45deg);
        > div {
            float: left;
            width: 50%;
            height: 50%;
            position: relative;
            transform: scale(1.1);
            div {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                animation: uik-loader-fold 2.4s infinite linear both;
                transform-origin: 100% 100%;
            }
        }
        > div:nth-child(2) {
            transform: scale(1.1) rotateZ(90deg);
            div {
                animation-delay: 0.3s;
            }
        }
        > div:nth-child(3) {
            transform: scale(1.1) rotateZ(270deg);
            div {
                animation-delay: 0.9s;
            }
        }
        > div:nth-child(4) {
            transform: scale(1.1) rotateZ(180deg);
            div {
                animation-delay: 0.6s;
            }
        }
    }
    .uik-loader__cubes {
        width: 40px;
        height: 40px;
        margin: 0 auto;
        position: relative;
        div {
            width: 15px;
            height: 15px;
            position: absolute;
            top: 0;
            left: 0;
            animation: uik-loader-cubes 1.8s infinite ease-in-out;
        }
        div:nth-child(2) {
            animation-delay: -0.9s;
        }
    }
    .primary {
        background: $primary;
    }
    .secondary {
        background: $secondary;
    }
    .success {
        background: $success;
    }
    .error {
        background: $error;
    }
    .warning {
        background: $warning;
    }
    .textMain {
        background: $textMain;
    }
    .textSecondary {
        background: $textSecondary;
    }
    @keyframes uik-loader-spinner {
        0%, 80%, 100% {
            transform: scale(0);
        }
        40% {
            transform: scale(1);
        }
    }
    @keyframes uik-loader-spinner-fade {
        0%, 39%, 100% {
            opacity: 0;
        }
        40% {
            opacity: 1;
        }
    }
    @keyframes uik-loader-bounce {
        0%, 100% {
            transform: scale(0);
        }
        50% {
            transform: scale(1);
        }
    }
    @keyframes uik-loader-ripple {
        0% {
            transform: scale(0);
            opacity: 1;
        }
        100% {
            transform: scale(1);
            opacity: 0;
        }
    }
    @keyframes uik-loader-dots {
        0%, 80%, 100% {
            transform: scale(0);
        }
        40% {
            transform: scale(1);
        }
    }
    @keyframes uik-loader-bars {
        0%, 40%, 100% {
            transform: scaleY(0.4);
        }
        20% {
            transform: scaleY(1);
        }
    }
    @keyframes uik-loader-blocks {
        0%, 70%, 100% {
            transform: scale3d(1, 1, 1);
        }
        35% {
            transform: scale3d(0, 0, 1);
        }
    }
    @keyframes uik-loader-rotate {
        0% {
            transform: perspective(120px);
        }
        50% {
            transform: perspective(120px) rotateY(180deg);
        }
        100% {
            transform: perspective(120px) rotateY(180deg) rotateX(180deg);
        }
    }
    @keyframes uik-loader-fold {
        0%, 10% {
            transform: perspective(140px) rotateX(-180deg);
            opacity: 0;
        }
        25%, 75% {
            transform: perspective(140px) rotateX(0deg);
            opacity: 1;
        }
        90%, 100% {
            transform: perspective(140px) rotateY(180deg);
            opacity: 0;
        }
    }
    @keyframes uik-loader-cubes {
        25% {
            transform: translateX(25px) rotate(-90deg) scale(0.5);
        }
        50% {
            transform: translateX(25px) translateY(25px) rotate(-179deg);
        }
        50.1% {
            transform: translateX(25px) translateY(25px) rotate(-180deg);
        }
        75% {
            transform: translateX(0px) translateY(25px) rotate(-270deg) scale(0.5);
        }
        100% {
            transform: rotate(-360deg);
        }
    }
}
</style>
